<nb-card accent="primary" class="modal-full">
    <nb-card-header style="display: flex;flex-direction: row;">
        <div style="flex: 1;">{{ title }}</div>
        <div style="flex: 1;justify-content: end;display: flex;">
            <nb-actions size="small">
                <!-- <nb-action icon="more-vertical-outline" (click)="openSummary()"></nb-action> -->
                <nb-action icon="close-outline" (click)="dismiss()"></nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <ng-container *ngIf="findForm">
        <ubs-lookup-dialog-form-container [ofbizForm]="findForm" [title]="title" (setLookupSelectedValue)="getLookupSelectedValue($event)"></ubs-lookup-dialog-form-container>
    </ng-container>
    <ng-container *ngIf="listForm">
        <ubs-lookup-dialog-list-container [listForm]="listForm" title="title"></ubs-lookup-dialog-list-container>
    </ng-container>

</nb-card>

